import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import {StyledInformationBox} from '../AdminPanelStyling'
import {StyledRequirementIcon, StyledRuleRow} from './ValidationRulesStyle'

const ValidationRules = ({refuseNumbers, refuseSpecialCharacters}) => {
  return (
    <StyledInformationBox>
      {refuseNumbers && (
        <StyledRuleRow>
          <StyledRequirementIcon />
          <Typography>No numbers allowed</Typography>
        </StyledRuleRow>
      )}
      {refuseSpecialCharacters && (
        <StyledRuleRow>
          <StyledRequirementIcon />
          <Typography>No special characters allowed</Typography>
        </StyledRuleRow>
      )}
    </StyledInformationBox>
  )
}

ValidationRules.propTypes = {
  refuseNumbers: PropTypes.bool,
  refuseSpecialCharacters: PropTypes.bool
}

export default ValidationRules
